import { Card, Col, DatePicker, Form, Input, Row, Select, Typography } from 'antd'
import React from 'react'
import CustomButton from '../../../../components/custom/CustomButton';
import LoanProducts from "../../../../config/data/loanProducts.json"

const { Text } = Typography;

const NewEntityMappingForm = ({
    onSelectStartDate,
    onSelectEndDate,
    addEntityMapping,
    name,
    productName,
    productLabel,
    onCancel }) => {

    return (
        <Card style={{
            marginBottom: "2%",
            boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
        }}
            title={"Add New Entity Mapping"}>
            <Row style={{ justifyContent: "space-between" }}>

                <Col span={6}>
                    <Form.Item
                        label={<Text strong>{name}</Text>}
                        name={name}>
                        <Select
                            placeholder="Select Branch"
                            showSearch
                            style={{ width: "30vh" }}
                            options={LoanProducts} />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        label={<Text strong>{productLabel}</Text>}
                        name={productName}>
                        <Select
                            placeholder={"Select"}
                            showSearch
                            style={{ width: "30vh" }}
                            options={LoanProducts} />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        label={<Text strong>Start Date</Text>}
                        name={"startDate"}>
                        <DatePicker
                            placeholder={"Start Date"}
                            style={{ width: "30vh" }}
                            onChange={onSelectStartDate} />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        label={<Text strong>End Date</Text>}
                        name={"endDate"}>
                        <DatePicker
                            placeholder={"End Date"}
                            style={{ width: "30vh" }}
                            onChange={onSelectEndDate} />
                    </Form.Item>
                    <Form.Item>
                    <CustomButton
                        content="Submit"
                        style={{
                            width: "40%",
                            marginLeft: "auto",
                            boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                        }}
                        htmlType="submit"
                        backgroundColor="#15CCAE"
                        colorText="black"
                        hoverBackground="#4FECA0"
                        onClick={addEntityMapping}
                    />
                    <CustomButton
                        content="Cancel"
                        style={{
                            width: "40%",
                            marginLeft: "1%",
                            boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                        }}
                        backgroundColor="#fff"
                        colorText="black"
                        hoverBackground="#F5F5F5"
                        onClick={onCancel}
                    />
            </Form.Item>
                </Col>
            </Row>
           
        </Card>
    )
}

export default NewEntityMappingForm